module.exports = __webpack_public_path__ + "static/media/genre.4781767e.svg";